import React, { useState } from "react";
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import homeLogo from "../Assets/logo192.png";
import Install from "../components/Install/Install"
import ReactPWAInstallProvider from "react-pwa-install";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";
import { CgMenu } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  //<img src={logo} className="img-fluid logo" alt="brand" />

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/Home/" className="d-flex">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid1"
                style={{height: "64px", width: "64px"}}
              />
        </Navbar.Brand>

        <Nav>
          <ReactPWAInstallProvider enableLogging>
            <Install />
          </ReactPWAInstallProvider>
        </Nav>

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link 
                as={Link}
                to="/Home/"
                /*onClick={() => updateExpanded(false)} */
                onClick={() => document.getElementById('home').scrollIntoView(updateExpanded(false))}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
              /*as={Link}
                to="/Home/chisiamo"
                onClick={() => updateExpanded(false)} */
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('chisiamo').scrollIntoView(updateExpanded(false))}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> Chi Siamo
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link 
               /* as={Link}
                to="/Home/servizi"           
                onClick={() => updateExpanded(false)} */
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('servizi').scrollIntoView(updateExpanded(false))}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                Servizi
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
              /*  as={Link}
                to="/Home/contatti"
                onClick={() => updateExpanded(false)} */
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('contatti').scrollIntoView(updateExpanded(false))}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Contatti
              </Nav.Link>
            </Nav.Item>

            <NavDropdown title={<CgMenu style={{ marginBottom: "2px" }}/>}  id="navbarScrollingDropdown" >

 
              <Nav.Link
              as={Link}
                to="/Home/notizie"
                onClick={() => updateExpanded(false)} 
              >
                Notizie
              </Nav.Link>

              <Nav.Link
              /*as={Link}
                to="/Home/comeunirti"
                onClick={() => updateExpanded(false)} */
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('comeunirti').scrollIntoView(updateExpanded(false))}
              >
                Unisciti
              </Nav.Link>
              
              <Nav.Link
              /*as={Link}
                to="/Home/areariservata"
                onClick={() => updateExpanded(false)} */
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('areariservata').scrollIntoView(updateExpanded(false))}
              >
                Area Riservata
              </Nav.Link>

{/*           <Nav.Link
                as={Link}
                to="/Home/cosadicono"
                onClick={() => updateExpanded(false)} 
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('cosadicono').scrollIntoView(updateExpanded(false))}
              >
                Cosa Dicono
              </Nav.Link>
*/}
              <Nav.Link
              /*as={Link}
                to="/Home/certificazioni"
                onClick={() => updateExpanded(false)} */
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('certificazioni').scrollIntoView(updateExpanded(false))}
              >
                Certificazioni
              </Nav.Link>

{/*           <Nav.Link
                as={Link}
                to="/Home/notizie"
                onClick={() => updateExpanded(false)} 
                as={Link}
                to="/Home/"
                onClick={() => document.getElementById('notizie').scrollIntoView(updateExpanded(false))}
              >
                Notizie
              </Nav.Link>
*/}

            </NavDropdown>

            <Nav.Item>
            </Nav.Item>

            <Nav.Item>
            </Nav.Item>

            <Nav.Item>
            </Nav.Item>

             <Nav.Item>
            </Nav.Item>
            
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
